module.exports = __webpack_public_path__ + "static/media/New_F.7ddc57e6.jpg";